import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MomentModule } from 'angular2-moment';
import { MomentTimezoneModule } from 'angular-moment-timezone';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { ClickOutsideModule } from 'ng-click-outside';
import { Ng2SimplePageScrollModule } from 'ng2-simple-page-scroll';

import { AppComponent } from './app.component';
import { routing } from "./routes";
import { environment } from '../environments/environment';

import { BsDropdownModule } from 'ng2-bootstrap';
import { DropzoneModule } from 'angular2-dropzone-wrapper';
import { DropzoneConfigInterface } from 'angular2-dropzone-wrapper';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';

import { AndrewsPageComponent } from './andrews-page/andrews-page.component';
import { LeftPaneComponent } from './shared/components/left-pane/left-pane.component';
import { HomePageComponent } from './shared/components//home-page/home-page.component';
import { NavBarComponent } from './shared/components//nav-bar/nav-bar.component';
import { LoginPageComponent } from './shared/components//login-page/login-page.component';

import { UserService } from './shared/services/user.service';
import { AppService } from './shared/services/app.service';
import { ProvinceService } from './onboarding/services/province.service';
import { CompanyService } from './onboarding/services/company.service';
import { ContactService } from './onboarding/services/contact.service';
import { DepartmentService } from './onboarding/services/department.service';
import { EhtService } from './onboarding/services/eht.service';
import { OrganizationService } from './onboarding/services/organization.service';
import { PayrollScheduleService } from './onboarding/services/payroll-schedule.service';
import { RemittanceInfoService } from './onboarding/services/remittance-info.service';
import { VacationsService } from './onboarding/services/vacations.service';
import { BusinessinfoService } from './onboarding/services/businessinfo.service';
import { BankingInfoService } from './onboarding/services/banking-info.service';
import { WcbService } from './onboarding/services/wcb.service';
import { AdminService } from './admin/services/admin.service';
import { FileService } from './onboarding/services/file.service';

import { SrcPipe } from './shared/pipes/src.pipe';
import { AddCompanyPageComponent } from './onboarding/components/add-company-page/add-company-page.component';
import { MultipleCompanyDashboardPageComponent } from './onboarding/components/multiple-company-dashboard-page/multiple-company-dashboard-page.component';
import { SingleCompanyDashboardPageComponent } from './onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component';
import { AddUsersPageComponent } from './onboarding/components/add-users-page/add-users-page.component';
import { CreateUserPageComponent } from './onboarding/components/create-user-page/create-user-page.component';
import { ImportUserPageComponent } from './onboarding/components/import-user-page/import-user-page.component';
import { DepartmentPageComponent } from './onboarding/components/department-page/department-page.component';
import { AddDepartmentPageComponent } from './onboarding/components/add-department-page/add-department-page.component';
import { ImportDepartmentPageComponent } from './onboarding/components/import-department-page/import-department-page.component';
import { ImportPositionPageComponent } from './onboarding/components/import-position-page/import-position-page.component';
import { BusinessInfoPageComponent } from './onboarding/components/company-setup/business-info-page/business-info-page.component';
import { RemittanceInfoPageComponent } from './onboarding/components/company-setup/remittance-info-page/remittance-info-page.component';
import { BankingInfoPageComponent } from './onboarding/components/company-setup/banking-info-page/banking-info-page.component';
import { PayrollSchedulePageComponent } from './onboarding/components/company-setup/payroll-schedule-page/payroll-schedule-page.component';
import { WcbPageComponent } from './onboarding/components/company-setup/wcb-page/wcb-page.component';
import { EhtPageComponent } from './onboarding/components/company-setup/eht-page/eht-page.component';
import { UploadDocumentsPageComponent } from './onboarding/components/upload-documents-page/upload-documents-page.component';
import { TimeOffPoliciesPageComponent } from './onboarding/components/time-off-policies-page/time-off-policies-page.component';
import { OnboardingPageComponent } from './onboarding/components/onboarding-page/onboarding-page.component';
import { MultipleCompaniesPageComponent } from './onboarding/components/multiple-companies-page/multiple-companies-page.component';
import { StepsComponent } from './onboarding/components/company-setup/steps/steps.component';
import { SetupBarComponent } from './onboarding/components/company-setup/setup-bar/setup-bar.component';
import { BottomBarComponent } from './onboarding/components/company-setup/bottom-bar/bottom-bar.component';
import { TopBarComponent } from './onboarding/components/top-bar/top-bar.component';
import { RegisterPageComponent } from './onboarding/components/register-page/register-page.component';
import { ReviewPageComponent } from './admin/components/review-page/review-page.component';
import { DashboardPageComponent } from './admin/components/dashboard-page/dashboard-page.component';
import { AdminPageComponent } from './admin/components/admin-page/admin-page.component';
import { AdminTopBarComponent } from './admin/components/admin-top-bar/admin-top-bar.component';
import { UnauthorizedPageComponent } from './admin/components/unauthorized-page/unauthorized-page.component';
import { DocumentsPageComponent } from './admin/components/documents-page/documents-page.component';
import { FileNamePipe } from './onboarding/pipes/file-name.pipe';
import { CompanyInfoService } from './onboarding/services/company-info.service';
import { IsLoggedIn } from './shared/guards/is-logged-in';
import { CompanyInfoPageComponent } from './onboarding/components/company-info-page/company-info-page.component';
import { OnboardingSuccessPageComponent } from './onboarding/components/onboarding-success-page/onboarding-success-page.component';
import { TruncatePipe } from './shared/pipes/truncate.pipe';
import { ConfirmationPageComponent } from './shared/components/confirmation-page/confirmation-page.component';
import { SubmitPageComponent } from './onboarding/components/submit-page/submit-page.component';
import { EmailVerifyPageComponent } from './onboarding/components/email-verify-page/email-verify-page.component';
import { ProvincePipe } from './shared/pipes/province.pipe';
import { RouterLinkStubDirective } from './testing/router-link-stub.directive';
import { ResetPasswordPageComponent } from './shared/components/reset-password-page/reset-password-page.component';
import { MyProfilePageComponent } from './shared/components/my-profile-page/my-profile-page.component';
import { SentryErrorHandler } from './sentry-error-handler';

const DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 2,
  acceptedFiles: 'doc,docx,pdf,txt'
};

export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    AndrewsPageComponent,
    LeftPaneComponent,
    HomePageComponent,
    NavBarComponent,
    LoginPageComponent,
    SrcPipe,
    AddCompanyPageComponent,
    MultipleCompanyDashboardPageComponent,
    SingleCompanyDashboardPageComponent,
    AddUsersPageComponent,
    CreateUserPageComponent,
    ImportUserPageComponent,
    DepartmentPageComponent,
    AddDepartmentPageComponent,
    ImportDepartmentPageComponent,
    ImportPositionPageComponent,
    BusinessInfoPageComponent,
    RemittanceInfoPageComponent,
    BankingInfoPageComponent,
    PayrollSchedulePageComponent,
    WcbPageComponent,
    EhtPageComponent,
    UploadDocumentsPageComponent,
    TimeOffPoliciesPageComponent,
    OnboardingPageComponent,
    MultipleCompaniesPageComponent,
    StepsComponent,
    SetupBarComponent,
    BottomBarComponent,
    TopBarComponent,
    RegisterPageComponent,
    ReviewPageComponent,
    DashboardPageComponent,
    AdminPageComponent,
    AdminTopBarComponent,
    UnauthorizedPageComponent,
    DocumentsPageComponent,
    FileNamePipe,
    CompanyInfoPageComponent,
    OnboardingSuccessPageComponent,
    TruncatePipe,
    ConfirmationPageComponent,
    SubmitPageComponent,
    EmailVerifyPageComponent,
    ProvincePipe,
    RouterLinkStubDirective,
    ResetPasswordPageComponent,
    MyProfilePageComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    routing,
    BsDropdownModule.forRoot(),
    DropzoneModule.forRoot(DROPZONE_CONFIG),
    NgxMyDatePickerModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),
    MomentModule,
    MomentTimezoneModule,
    Ng2Bs3ModalModule,
    ClickOutsideModule,
    Ng2SimplePageScrollModule.forRoot(),
  ],
  providers: [
    UserService,
    AppService,
    ProvinceService,
    CompanyService,
    ContactService,
    DepartmentService,
    EhtService,
    OrganizationService,
    PayrollScheduleService,
    RemittanceInfoService,
    VacationsService,
    BusinessinfoService,
    BankingInfoService,
    WcbService,
    AdminService,
    FileService,
    FileNamePipe,
    IsLoggedIn,
    CompanyInfoService,
    { provide: ErrorHandler, useClass: environment.SENTRY_ENABLED ? SentryErrorHandler : ErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts